export const DefaultValueConfig = {
    imagePlaceholder: '/images/placeholder.png',
    href: '/',
    maxFreeShippingPrice: 60,
    alt: '',
};
